import { customSwitch } from 'utils/customSwitchCase/customSwitch';
import { notificationFilterName } from './Filters/utils';
import { NotificationMetric } from './KPIMetric/Tile';

export const matchNotificationFilterWithTile = (values): string => {
  if (
    values[notificationFilterName.communicationType].length === 1 &&
    values[notificationFilterName.communicationType][0].value === 'Call' &&
    values[notificationFilterName.communicationDirection].length === 1 &&
    values[notificationFilterName.communicationDirection][0].value === 'Outbound' &&
    !values[notificationFilterName.status].length
  ) {
    return NotificationMetric.CallOut;
  }
  if (
    values[notificationFilterName.communicationType].length === 1 &&
    values[notificationFilterName.communicationType][0].value === 'Call' &&
    values[notificationFilterName.communicationDirection].length === 1 &&
    values[notificationFilterName.communicationDirection][0].value === 'Inbound' &&
    !values[notificationFilterName.status].length
  ) {
    return NotificationMetric.CallIn;
  }
  if (
    values[notificationFilterName.communicationType].length === 1 &&
    values[notificationFilterName.communicationType][0].value === 'SMS' &&
    values[notificationFilterName.communicationDirection].length === 1 &&
    values[notificationFilterName.communicationDirection][0].value === 'Outbound' &&
    !values[notificationFilterName.status].length
  ) {
    return NotificationMetric.MessageOut;
  }
  if (
    values[notificationFilterName.communicationType].length === 1 &&
    values[notificationFilterName.communicationType][0].value === 'SMS' &&
    values[notificationFilterName.communicationDirection].length === 1 &&
    values[notificationFilterName.communicationDirection][0].value === 'Inbound' &&
    !values[notificationFilterName.status].length
  ) {
    return NotificationMetric.MessageIn;
  }
  if (
    values[notificationFilterName.status].length === 1 &&
    values[notificationFilterName.status][0].value === 'Call' &&
    values[notificationFilterName.status][0].children.length === 1 &&
    values[notificationFilterName.status][0].children[0].value === 'Spoke To Candidate' &&
    !values[notificationFilterName.communicationType].some(item => item.value === 'SMS' || item.value === 'Email')
  ) {
    return NotificationMetric.SpokeToCandidate;
  }
  if (
    values[notificationFilterName.communicationType].length === 1 &&
    values[notificationFilterName.communicationType][0].value === 'Email' &&
    values[notificationFilterName.communicationDirection].length === 1 &&
    values[notificationFilterName.communicationDirection][0].value === 'Outbound'
  ) {
    return NotificationMetric.EmailSent;
  }
  return '';
};

interface filterPayload {
  direction: string;
  deliveryStatus: string[];
  channel: string[];
}

export const getNotificationKpiFilterPayload = filterValue => {
  const payload: filterPayload = { direction: '', deliveryStatus: [], channel: [] };
  if (filterValue[notificationFilterName.communicationDirection]?.length === 1)
    payload.direction = filterValue[notificationFilterName.communicationDirection][0]?.value;
  if (filterValue[notificationFilterName.communicationType]?.length) {
    const selectedChannel = filterValue[notificationFilterName.communicationType]?.map(item => item.value);
    payload.channel = selectedChannel.map(x => x.replace('SMS', 'Conversation').replace('Call', 'Voice'));
  }
  if (filterValue[notificationFilterName.status].length)
    payload.deliveryStatus = filterValue[notificationFilterName.status]
      .map(item => item.children?.map(child => child.value?.toLowerCase()))
      .flat(1);

  return payload;
};

export const getTaskKpiFilterPayload = filterValue => {
  const payload: filterPayload = { direction: '', deliveryStatus: [], channel: [] };

  return payload;
};

export const matchNotificationTileWithFilter = customSwitch({
  [NotificationMetric.CallIn]: {
    [notificationFilterName.communicationType]: [
      {
        id: 0,
        name: 'Call',
        value: 'Call',
      },
    ],
    [notificationFilterName.initiatedBy]: [
      {
        id: 0,
        name: 'Me',
        value: 'Me',
      },
    ],
    [notificationFilterName.communicationDirection]: [
      {
        id: 0,
        name: 'Inbound',
        value: 'Inbound',
      },
    ],
    [notificationFilterName.status]: [],
  },
  [NotificationMetric.CallOut]: {
    [notificationFilterName.communicationType]: [
      {
        id: 0,
        name: 'Call',
        value: 'Call',
      },
    ],
    [notificationFilterName.initiatedBy]: [
      {
        id: 0,
        name: 'Me',
        value: 'Me',
      },
    ],
    [notificationFilterName.communicationDirection]: [
      {
        id: 0,
        name: 'Outbound',
        value: 'Outbound',
      },
    ],
    [notificationFilterName.status]: [],
  },
  [NotificationMetric.SpokeToCandidate]: {
    [notificationFilterName.communicationType]: [
      {
        id: 0,
        name: 'Call',
        value: 'Call',
      },
    ],
    [notificationFilterName.initiatedBy]: [
      {
        id: 0,
        name: 'Me',
        value: 'Me',
      },
    ],
    [notificationFilterName.communicationDirection]: [],
    [notificationFilterName.status]: [
      {
        value: 'Call',
        name: 'Call',
        children: [
          {
            value: 'Spoke To Candidate',
            name: 'Spoke To Candidate',
          },
        ],
      },
    ],
  },
  [NotificationMetric.EmailSent]: {
    [notificationFilterName.communicationType]: [
      {
        id: 0,
        name: 'Email',
        value: 'Email',
      },
    ],
    [notificationFilterName.initiatedBy]: [
      {
        id: 0,
        name: 'Me',
        value: 'Me',
      },
    ],
    [notificationFilterName.communicationDirection]: [
      {
        id: 0,
        name: 'Outbound',
        value: 'Outbound',
      },
    ],
    [notificationFilterName.status]: [],
  },
  [NotificationMetric.OpenRate]: {
    [notificationFilterName.communicationType]: [
      {
        id: 0,
        name: 'Email',
        value: 'Email',
      },
    ],
    [notificationFilterName.initiatedBy]: [
      {
        id: 0,
        name: 'Me',
        value: 'Me',
      },
    ],
    [notificationFilterName.communicationDirection]: [],
    [notificationFilterName.status]: [
      {
        value: 'Email',
        name: 'Email',
        children: [
          {
            value: 'Open',
            name: 'Open',
          },
          {
            value: 'Click',
            name: 'Click',
          },
        ],
      },
    ],
  },
  [NotificationMetric.MessageIn]: {
    [notificationFilterName.communicationType]: [
      {
        id: 0,
        name: 'SMS',
        value: 'SMS',
      },
    ],
    [notificationFilterName.initiatedBy]: [
      {
        id: 0,
        name: 'Me',
        value: 'Me',
      },
    ],
    [notificationFilterName.communicationDirection]: [
      {
        id: 0,
        name: 'Inbound',
        value: 'Inbound',
      },
    ],
    [notificationFilterName.status]: [],
  },
  [NotificationMetric.MessageOut]: {
    [notificationFilterName.communicationType]: [
      {
        id: 0,
        name: 'SMS',
        value: 'SMS',
      },
    ],
    [notificationFilterName.initiatedBy]: [
      {
        id: 0,
        name: 'Me',
        value: 'Me',
      },
    ],
    [notificationFilterName.communicationDirection]: [
      {
        id: 0,
        name: 'Outbound',
        value: 'Outbound',
      },
    ],
    [notificationFilterName.status]: [],
  },
})(undefined);
